import { Button } from '@rescui/button';
import { Dropdown } from '@rescui/dropdown';
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { CHANGE_PARAMETER_VALUE } from '../redux/actionTypes';
import { connect } from 'react-redux';
import { FilterIcon } from '@rescui/icons';
import './styles/ktor-options.css';
import { Select } from '@rescui/select';
import { valueToSelectOption } from '../services/formUtils';
import { createTextCn } from '@rescui/typography';
import cn from 'classnames';
import KtorLogo from '../KtorLogo';

const KtorOptions = ({
  buildSystem,
  ktorVersion,
  engine,
  configurationIn,
  settingsOptions,
  settingsLoaded,
  changeParameter,
  flatten,
  theme,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const textCn = createTextCn(theme);
  const toggleForm = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);
  const {
    buildSystem: buildSystemOptions,
    engine: engineOptions,
    configurationIn: configurationInOptions,
  } = settingsOptions;
  const labelCn = cn(textCn('rs-text-2', { hardness: 'hard' }));
  const selectedEngine = engineOptions?.find((option) => option.id === engine) ||
    engineOptions[0];

  return (
    <div className={cn('ktor-options', { flatten })}>
      { settingsLoaded &&
        <div className={textCn('rs-text-3', { 'hardness': 'hard' })}>
          <div className="ktor-options__summary">
            <KtorLogo height="18px" />
            <span>{ktorVersion}</span>
            <span className="engine">{selectedEngine?.label}</span>
          </div>

          {/* <div className="ktor-options__promo">*/}
          {/*  <a className={textCn('rs-link', { external: true, hardness: 'hard' })}*/}
          {/*    href="https://surveys.jetbrains.com/s3/010047c51608">*/}
          {/*    Take the Ktor 2025 survey*/}
          {/*  </a>*/}
          {/* </div>*/}
        </div>
      }

      <Dropdown
        trigger={
          <Button
            icon={<FilterIcon />}
            iconPosition="right"
            size="s"
            mode={flatten ? 'clear' : 'outline'}
            onClick={toggleForm}
          >
            { 'Configure' }
          </Button>
        }
        isOpen={isOpen}
      >
        <form className="ktor-options__content rs-text-2 rs-text-2_hardness_hard">

          <label className={labelCn} htmlFor="build-system">
            Build system
          </label>
          <Select
            id="build-system"
            size="s"
            theme={theme}
            placeholder="Choose a build system..."
            value={valueToSelectOption(buildSystem, buildSystemOptions)}
            onChange={(e) => changeParameter('buildSystem', e.value)}
            options={buildSystemOptions}
          />

          <label className={labelCn} htmlFor="engine">
            Engine
          </label>
          <Select
            id="engine"
            size="s"
            theme={theme}
            placeholder="Choose engine..."
            value={valueToSelectOption(engine, engineOptions)}
            onChange={(e) => changeParameter('engine', e.value)}
            options={engineOptions}
          />

          <label className={labelCn} htmlFor="configuration-in">
            Configuration
          </label>
          <Select
            id="configuration-in"
            size="s"
            theme={theme}
            placeholder="Choose configuration..."
            value={valueToSelectOption(configurationIn, configurationInOptions)}
            onChange={(e) => changeParameter('configurationIn', e.value)}
            options={configurationInOptions}
          />

          <div className="ktor-options__footer">
            <div></div>
            <Button
              mode="rock"
              size="s"
              onClick={toggleForm}
            >
              Done
            </Button>
          </div>
        </form>
      </Dropdown>
    </div>
  );
};

const optionType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

KtorOptions.propTypes = {
  buildSystem: PropTypes.string,
  buildSystemArgs: PropTypes.object,
  website: PropTypes.string,
  ktorVersion: PropTypes.string,
  engine: PropTypes.string,
  configurationIn: PropTypes.string,
  addSampleCode: PropTypes.bool,
  addedFeatures: PropTypes.arrayOf(PropTypes.string),
  settingsOptions: PropTypes.shape({
    buildSystem: PropTypes.arrayOf(optionType),
    ktorVersion: PropTypes.arrayOf(optionType),
    engine: PropTypes.arrayOf(optionType),
    configurationIn: PropTypes.arrayOf(optionType),
  }),
  settingsLoaded: PropTypes.bool,
  theme: PropTypes.string,
  changeParameter: PropTypes.func.isRequired,
  flatten: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => ({
  changeParameter: (name, value) =>
    dispatch({
      type: CHANGE_PARAMETER_VALUE,
      payload: { name, value },
    }),
});

const mapStateToProps = ({ projectConfig, options, settingsLoaded, theme }) => ({
  buildSystem: projectConfig.buildSystem,
  buildSystemArgs: projectConfig.buildSystemArgs || {},
  ktorVersion: projectConfig.ktorVersion,
  engine: projectConfig.engine,
  configurationIn: projectConfig.configurationIn,
  settingsOptions: options,
  addSampleCode: projectConfig.addSampleCode,
  theme: theme,
  settingsLoaded,
});

export default connect(mapStateToProps, mapDispatchToProps)(KtorOptions);

